module.exports = __webpack_public_path__ + "2e4d03ec7471a935a860bd40bc215556.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/gears4/dam.png
// module id = 1053
// module chunks = 0